import { inject, Injectable } from '@angular/core';
import { AgenticApiClient } from '../../lib/agentic-api/grpc/agentic_api.client';
import type { InsightResponse } from '../../lib/agentic-api/grpc/agentic_insight';
import { GrpcClientService } from '../core/grpc-client.service';

@Injectable({ providedIn: 'root' })
export class InsightApiService {
  private readonly grpc = inject(GrpcClientService);
  private readonly client = new AgenticApiClient(this.grpc.transport);

  updateItem(
    insightId: string,
    itemId: string,
    reviewStatus: string,
    reviewNote: string,
    followUpStatus: string,
    followUpReference: string,
  ): Promise<InsightResponse> {
    return this.grpc.unary(options =>
      this.client.updateInsightItem(
        {
          idempotencyKey: { value: crypto.randomUUID() },
          insightId,
          itemId,
          reviewStatus,
          reviewNote: reviewNote ? { value: reviewNote } : undefined,
          followUpStatus,
          followUpReference: followUpReference ? { value: followUpReference } : undefined,
        },
        options,
      ),
    );
  }
}
